import { render, staticRenderFns } from "./Idp.vue?vue&type=template&id=cde97ec0&scoped=true"
import script from "./Idp.vue?vue&type=script&lang=js"
export * from "./Idp.vue?vue&type=script&lang=js"
import style0 from "./Idp.vue?vue&type=style&index=0&id=cde97ec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde97ec0",
  null
  
)

export default component.exports